import { createClient } from '@supabase/supabase-js';
import { supabaseAuthStorage } from './authStorage';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (import.meta.env.DEV) {
  console.log('=== Supabase 環境變數調試 ===');
  console.log('VITE_SUPABASE_URL:', supabaseUrl);
  console.log('VITE_SUPABASE_ANON_KEY:', supabaseAnonKey ? '已設置' : '未設置');
}

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: supabaseAuthStorage,
  },
  global: {
    headers: {
      'X-Client-Info': 'fixnow-web-app'
    }
  }
});

// 添加連接狀態檢查輔助函數
export async function checkSupabaseConnection(): Promise<{
  isConnected: boolean;
  error?: string;
  isPaused?: boolean;
}> {
  try {
    // 勿查詢 users（RLS 擋 anon、且無名為 count 的欄位）；先打 Auth health，失敗再試公開可讀表
    const base = supabaseUrl.replace(/\/$/, '');
    const healthRes = await fetch(`${base}/auth/v1/health`, {
      headers: {
        apikey: supabaseAnonKey,
        Authorization: `Bearer ${supabaseAnonKey}`,
      },
    });
    if (healthRes.ok) {
      return { isConnected: true };
    }

    const { error } = await supabase.from('craftsmen').select('id').limit(1);

    if (error) {
      // 檢查是否是 CORS 錯誤（通常表示項目已暫停）
      if (error.message.includes('Failed to fetch') || error.message.includes('CORS')) {
        return {
          isConnected: false,
          error: '⚠️ Supabase 項目可能已暫停。請訪問 https://supabase.com/dashboard 並恢復項目。',
          isPaused: true
        };
      }
      
      return {
        isConnected: false,
        error: `連接錯誤: ${error.message}`
      };
    }
    
    return { isConnected: true };
  } catch (error: any) {
    if (error.message?.includes('Failed to fetch')) {
      return {
        isConnected: false,
        error: '⚠️ 無法連接到 Supabase。請檢查:\n1. Supabase 項目是否已暫停\n2. 網絡連接是否正常\n3. 防火牆設置',
        isPaused: true
      };
    }
    
    return {
      isConnected: false,
      error: `未知錯誤: ${error.message}`
    };
  }
}
